export default {
    label_task:{
        en:"Dealers Statement Summary Report",
        bn:'Variety Report'
    },
    label_achievement :{
        en:"Achievement(%)",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_from:{
        en:"Sales From",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_to:{
        en:"Sales To",
        bn:'ব্যবহারকারীরা'
    },
    label_target:{
        en:"Target",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_net:{
        en:"Net Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_gross:{
        en:"Gross Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_canceled:{
        en:"Canceled Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_payment_total:{
        en:"Total Payment",
        bn:'ব্যবহারকারীরা'
    },
    label_credit_limit:{
        en:"Credit Limit",
        bn:'ব্যবহারকারীরা'
    },
    label_opening_balance:{
        en:"Opening Balance",
        bn:'ব্যবহারকারীরা'
    },
    label_end_balance:{
        en:"End Balance",
        bn:'ব্যবহারকারীরা'
    },
    label_last_invoice_date:{
        en:"Last Invoice date",
        bn:'ব্যবহারকারীরা'
    },
    label_last_invoice_duration:{
        en:"Last Invoice Duration",
        bn:'ব্যবহারকারীরা'
    },
    label_last_payment_date:{
        en:"Last Payment Date",
        bn:'ব্যবহারকারীরা'
    },
    label_last_payment_duration:{
        en:"Last Payment Duration",
        bn:'ব্যবহারকারীরা'
    },

}